import React from 'react';
import { Box, Button, Text, TextButton } from '@wix/design-system';
import { useNavigation } from './navigation.hook';
import s from './trafficSuggestionsWidget.scss';
export const TrafficSuggestionsWidget = _ref => {
  var _cta$bizMgrNavigation, _cta$externalUrl;
  let {
    data: {
      description,
      cta
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  const {
    navigate
  } = useNavigation(cta);
  const title = ((_cta$bizMgrNavigation = cta.bizMgrNavigation) == null ? void 0 : _cta$bizMgrNavigation.title) || ((_cta$externalUrl = cta.externalUrl) == null ? void 0 : _cta$externalUrl.title);
  const moreSuggestionsText = 'Show me a different suggestion';
  const onSuggestOtherClick = () => {
    onWidgetAction(TRAFFIC_SUGGESTIONS_WIDGET, {
      action: 'suggest other',
      value: moreSuggestionsText
    });
    send(moreSuggestionsText);
  };
  const onSuggestionClick = e => {
    e.stopPropagation();
    onWidgetAction(TRAFFIC_SUGGESTIONS_WIDGET, {
      action: 'main cta',
      value: description
    });
    navigate();
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "thin",
    size: "small",
    marginButton: "10px"
  }, "Here\u2019s what I suggest for you:"), /*#__PURE__*/React.createElement("div", {
    onClick: onSuggestionClick
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.SuggestionContainer,
    direction: "vertical",
    padding: "12px",
    gap: "12px",
    borderRadius: "8px",
    border: "1px solid",
    borderColor: "B40"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, description), /*#__PURE__*/React.createElement(Box, {
    align: "left"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    skin: "ai",
    onClick: onSuggestionClick
  }, title)))), /*#__PURE__*/React.createElement(TextButton, {
    weight: "thin",
    size: "tiny",
    onClick: onSuggestOtherClick
  }, moreSuggestionsText));
};
export const TRAFFIC_SUGGESTIONS_WIDGET = 'TRAFFIC_SUGGESTIONS_WIDGET';
//# sourceMappingURL=trafficSuggestionsWidget.js.map